import React, {useEffect, useState} from 'react';


export const DelayedComponentRenderer = React.memo(function DelayedComponentRenderer (
    props: DelayedComponentRenderer.Props
) {
    const {
        delayMilliseconds,
        children
    } = props;

    const normalizedDelayMilliseconds = Math.max(0, delayMilliseconds);

    const [shouldRenderChildren, setShouldRenderChildren] = useState(normalizedDelayMilliseconds === 0);

    useEffect(() => {

        if (normalizedDelayMilliseconds === 0) {

            setShouldRenderChildren(true);
            return undefined;
        } else {
            // setShouldRenderChildren(false);

            const timeout = setTimeout(() => {
                setShouldRenderChildren(true)
            }, normalizedDelayMilliseconds)

            return () => {
                clearTimeout(timeout)
            }
        }


    }, [normalizedDelayMilliseconds]);

    return shouldRenderChildren ? children : null;
});

export namespace DelayedComponentRenderer {

    export interface Props {
        delayMilliseconds: number;
        children: React.ReactElement;
    }
}
